import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';
import { AccountingMovementsImportDialog } from './movements/import/accounting-movements-import-dialog';
import { MatDialog } from '@angular/material/dialog';
import { HeaderTabService } from '../../shared/components/header-tabs/header-tab.service';

@Component({
    selector: 'convfact-accountingtabs',
    templateUrl: './accounting-tabs.component.html',
    styleUrls: ['./accounting-tabs.component.scss'],
    standalone: false
})
export class AccountingTabsComponent implements OnInit {
  routes: object[];

  isSelected = false;
  isResponsive: boolean;

  constructor(
    public dialog: MatDialog,
    private headerTabService: HeaderTabService
  ) {
    this.routes = [
      { label: "Diario", link: "/accounting/diary", enable: true },
      { label: "Cuentas", link: "/accounting/accounts", enable: true },
      { label: "Perdidas y Ganancias", link: "/accounting/profitandloss", enable: true },
      { label: "Balance Pymes", link: "/accounting/balance", enable: true },
      { label: "Informes", link: "/accounting/reports/total", enable: true },
      { label: "Balance Sumas y Saldos", link: "/accounting/sumas", enable: true },
      { label: "Importar", link: "/accounting/import", enable: true },
      { label: 'Exportar', link: '/accounting/export', enable: true },
    ];
  }

  downloadFile() {
    const link = document.createElement('a');
    link.href = environment.apiUrl + '/INFORMES_CONTABILIDAD.xlsx';
    link.download = 'Informes_Contabilidad.xlsx';
    link.target = '_blank'; // Abre en una nueva pestaña
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  ngOnInit() {
    this.headerTabService.onEventSubject.subscribe(result => {
      const event = result.event;

      switch (event) {
        case 'on-select-tab':
          this.isSelected = true;
          break;
        case 'on-select-back':
          this.isSelected = false;
          break;
        case 'on-change-responsive':
          this.isResponsive = result.isResponsive;
          break;
      }
    });

  }

  onBack() {
    this.isSelected = false;
    this.headerTabService.onEvent({ event: 'on-select-back' });
  }

}
